import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { cadenceApi } from '@/lib/api';
import { queryKeys } from './shared';

// Cadences
export const useCadences = (workspaceId: string) =>
  useQuery({
    queryKey: queryKeys.cadences(workspaceId),
    queryFn: () => cadenceApi.list(workspaceId),
    enabled: !!workspaceId,
    staleTime: 30_000,
  });

export const useBrandCadences = (workspaceId: string, brandId: string | null) =>
  useQuery({
    queryKey: ['cadences', workspaceId, 'brand', brandId],
    queryFn: () => cadenceApi.listForBrand(workspaceId, brandId!),
    enabled: !!workspaceId && !!brandId,
    staleTime: 30_000,
  });

export const useUpsertCadence = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      brandId,
      platform,
      data,
    }: {
      brandId: string;
      platform: string;
      data: import('@/types').UpsertCadenceRequest;
    }) => cadenceApi.upsert(workspaceId, brandId, platform, data),
    onSuccess: (_data, { brandId }) => {
      qc.invalidateQueries({ queryKey: queryKeys.cadences(workspaceId) });
      qc.invalidateQueries({ queryKey: ['cadences', workspaceId, 'brand', brandId] });
    },
  });
};

export const useDeleteCadence = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ brandId, platform }: { brandId: string; platform: string }) =>
      cadenceApi.delete(workspaceId, brandId, platform),
    onSuccess: (_data, { brandId }) => {
      qc.invalidateQueries({ queryKey: queryKeys.cadences(workspaceId) });
      qc.invalidateQueries({ queryKey: ['cadences', workspaceId, 'brand', brandId] });
    },
  });
};
